// GENERATED FILE, PLEASE DO NOT EDIT
export var BannerDefault = 8;
export var ButtonToggleGroupLarge = 24;
export var ButtonToggleGroupMedium = 20;
export var ButtonToggleGroupSmall = 16;
export var ButtonDefault = 4;
export var CardDefault = 8;
export var FieldsInputDefault = 8;
export var FieldsInputConnectedWrapperDefault = 8;
export var ModalDefault = 16;
export var PaginationDefault = 20;
export var PopoverContainerDefault = 4;
export var TagDefault = 4;
export var ToastContainer = 24;
export var ToggleTypeCheckbox = 4;
export var ToggleTypeToggle = 24;
export var TooltipContainer = 4;
export var TooltipButtonClose = 24;